import React, { Component } from 'react';
import './input.css';

class Input extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      value: ""
    };        
  }
  
  componentWillReceiveProps(props) {
    this.setState({
      value: props.value
    });
  }
    
  render() {
    let inputProps = Object.assign({}, this.props, {
      onChange: (e) => this.onChange(e)      
    });

    delete inputProps.label;

    return (
      <div className="form-control">
        <label>{this.props.label}</label>
        <input {...inputProps} />
      </div>
    );
  } 

  getDisplayValue() {
    // Override to format display value
    return this.state.value;
  }
  
  formatValue(value) {
    // Override to format value
    return value;
  }

  onChange(e) { 
    this.props.onChange(this.formatValue(e.target.value), e);
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/form-elements/input/input.js